import { render } from "./AnnotationRightClickPopup.vue?vue&type=template&id=862462c8&scoped=true"
import script from "./AnnotationRightClickPopup.vue?vue&type=script&lang=js"
export * from "./AnnotationRightClickPopup.vue?vue&type=script&lang=js"

import "./AnnotationRightClickPopup.vue?vue&type=style&index=0&id=862462c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862462c8"]])

export default __exports__